<template>
    <div class="test-score-bar">
        <div class="test-score-bar__score" :style="{ left: scorePercent + '%' }">
            <span>{{ score }}</span>
            <check />
        </div>

        <div class="test-score-bar__track">
            <div class="test-score-bar__fill" :style="{ width: scorePercent + '%' }"></div>
            <div class="test-score-bar__threshold" v-if="threshold !== total" :style="{ left: thresholdPercent + '%' }"></div>
            <div class="test-score-bar__handle" :style="{ left: scorePercent + '%' }"></div>
        </div>

        <div class="test-score-bar__axis">
            <span class="test-score-bar__axis-start">0</span>
            <!-- when the threshold equals the total, the "end" label below already covers it -->
            <span v-if="threshold !== total" class="test-score-bar__axis-threshold" :style="{ left: thresholdPercent + '%' }">{{ threshold }}</span>
            <span class="test-score-bar__axis-end">{{ total }}</span>
        </div>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
import Check from "Components/Svg/Check";

export default {
    name : "TestScoreBar",

    components : { Check },

    props : {
        score : { type : Number, default : 0 },
        total : { type : Number, default : 0 },
        threshold : { type : Number, default : 0 }
    },

    computed : {
        scorePercent() { return this.toPercent(this.score); },
        thresholdPercent() { return this.toPercent(this.threshold); }
    },

    methods : {
        toPercent(value) {
            if (!this.total) { return 0; }
            return Math.min(100, Math.max(0, (value / this.total) * 100));
        }
    }
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" scoped>
.test-score-bar {
    position: relative;
    padding-top: 32px;

    &__score {
        position: absolute;
        top: 0;
        transform: translateX(-50%);
        display: inline-flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;
        font-weight: 700;
        font-size: 18px;

        svg {
            display: block;
            width: 18px;
            height: 18px;
        }
    }

    &__track {
        position: relative;
        height: 8px;
        border-radius: 4px;
        background: #E4EAF0;
    }

    &__fill {
        height: 100%;
        border-radius: 4px;
        background: linear-gradient(to right, #BFE0FF, #2870ED);
        transition: width 0.3s ease;
    }

    // thin marker on the track showing the pass threshold
    &__threshold {
        position: absolute;
        top: -3px;
        width: 2px;
        height: 14px;
        transform: translateX(-50%);
        background: rgba(255, 255, 255, 0.9);
        border-radius: 1px;
    }

    // handle "dot" at the current score position
    &__handle {
        position: absolute;
        top: 50%;
        width: 16px;
        height: 16px;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: #FFF;
        border: 3px solid #2870ED;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }

    &__axis {
        position: relative;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-weight: 700;
        color: #8DA5C5;

        &-threshold {
            position: absolute;
            top: 0;
            transform: translateX(-50%);
        }
    }
}
</style>
